import { fork } from 'redux-saga/effects';
import { IAppState, TActions } from '../../../common/state';

import {
  coworkingAdModalReducer,
  COWORKING_AD_MODAL_CLOSED,
  COWORKING_AD_MODAL_OPENED,
  ICoworkingAdModal,
  initialState as coworkingAdModalInitialState,
  TCoworkingAdModalActions,
  coworkingAdModalSagas,
} from './coworkingAdModal';
import {
  coworkingAdModalMiniReducer,
  COWORKING_AD_MODAL_MINI_CLOSED,
  COWORKING_AD_MODAL_MINI_OPENED,
  ICoworkingAdModalMini,
  initialState as coworkingAdModalMiniInitialState,
  TCoworkingAdModalMiniActions,
  coworkingAdModalMiniSagas,
} from './coworkingAdModalMini';
import {
  ICoworkingPopup,
  initialState as coworkingPopupInitialState,
  COWORKING_POPUP_OPENED,
  COWORKING_POPUP_CLOSED,
  coworkingPopupReducer,
  coworkingPopupSagas,
  TCoworkingPopupActions,
  SET_FILTERS_POSITION,
} from './coworkingPopup';
import {
  coworkingHelperSagas,
  COWORKING_HELPER_OPENED,
  COWORKING_HELPER_CLOSED,
  coworkingHelperReducer,
  ICoworkingHelper,
  initialState as coworkingHelperInitialState,
  TCoworkingHelperActions,
} from './coworkingHelper';

export type TCoworkingExperiments =
  | TCoworkingAdModalActions
  | TCoworkingAdModalMiniActions
  | TCoworkingPopupActions
  | TCoworkingHelperActions;
export interface ICoworkingExperiments {
  coworkingAdModal: ICoworkingAdModal;
  coworkingAdModalMini: ICoworkingAdModalMini;
  coworkingPopup: ICoworkingPopup;
  coworkingHelper: ICoworkingHelper;
}

export const initialState = {
  coworkingAdModal: coworkingAdModalInitialState,
  coworkingAdModalMini: coworkingAdModalMiniInitialState,
  coworkingPopup: coworkingPopupInitialState,
  coworkingHelper: coworkingHelperInitialState,
};

export const coworkingExperimentsReducer = (state: IAppState, action: TActions): IAppState => {
  switch (action.type) {
    case COWORKING_AD_MODAL_OPENED:
    case COWORKING_AD_MODAL_CLOSED:
      return {
        ...state,
        coworkingExperiments: {
          ...state.coworkingExperiments,
          coworkingAdModal: coworkingAdModalReducer(state.coworkingExperiments.coworkingAdModal, action),
        },
      };

    case COWORKING_AD_MODAL_MINI_OPENED:
    case COWORKING_AD_MODAL_MINI_CLOSED:
      return {
        ...state,
        coworkingExperiments: {
          ...state.coworkingExperiments,
          coworkingAdModalMini: coworkingAdModalMiniReducer(state.coworkingExperiments.coworkingAdModalMini, action),
        },
      };

    case COWORKING_POPUP_OPENED:
    case COWORKING_POPUP_CLOSED:
    case SET_FILTERS_POSITION:
      return {
        ...state,
        coworkingExperiments: {
          ...state.coworkingExperiments,
          coworkingPopup: coworkingPopupReducer(state.coworkingExperiments.coworkingPopup, action),
        },
      };

    case COWORKING_HELPER_OPENED:
    case COWORKING_HELPER_CLOSED:
      return {
        ...state,
        coworkingExperiments: {
          ...state.coworkingExperiments,
          coworkingHelper: coworkingHelperReducer(state.coworkingExperiments.coworkingHelper, action),
        },
      };

    default:
      return state;
  }
};

export function* coworkingExperimentsRootSaga() {
  yield fork(coworkingAdModalSagas);
  yield fork(coworkingAdModalMiniSagas);
  yield fork(coworkingPopupSagas);
  yield fork(coworkingHelperSagas);
}
